import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { BaseHttpService } from './core/http/base-http.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(private http: BaseHttpService, private router: Router) {
    let username = localStorage.getItem('meUsername');
    let token = localStorage.getItem('meToken')
    if (!username || !token) {
      this.router.navigateByUrl('/login');
    } else {
      this.http.username = username;
      this.http.token = token;
    }
    let useStr = localStorage.getItem('meUserInfo');
    this.http.userInfo = useStr ? JSON.parse(useStr) : null;
  }
}
